import { connect } from "react-redux";
import { compose } from "redux";

import { getHomeNews, resetHomeNews } from "./actions";
import { HomeNews as Component } from "./homeNews";
import {
  makeSelectIsError,
  makeSelectIsReady,
  makeSelectNews,
  makeSelectNextPage,
} from "./reducer";

const makeMapStateToProps = () => {
  const selectNews = makeSelectNews();
  const selectIsReady = makeSelectIsReady();
  const selectIsError = makeSelectIsError();
  const selectNextPage = makeSelectNextPage();
  const mapStateToProps = (state, ownProps) => ({
    isReady: selectIsReady(state, ownProps),
    isError: selectIsError(state, ownProps),
    news: selectNews(state, ownProps),
    nextPage: selectNextPage(state, ownProps),
  });

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
  onGetHomeNews: (data) => dispatch(getHomeNews(data)),
  onResetHomeNews: (data) => dispatch(resetHomeNews(data)),
});

export default compose(connect(makeMapStateToProps, mapDispatchToProps))(
  Component
);
